module.exports = __webpack_public_path__ + "media/stockholm/front_ship-8e79b0c8.jpg";